import { render, staticRenderFns } from "./DepartmentContacts.vue?vue&type=template&id=046cf616&scoped=true"
import script from "./DepartmentContacts.vue?vue&type=script&lang=js"
export * from "./DepartmentContacts.vue?vue&type=script&lang=js"
import style0 from "./DepartmentContacts.vue?vue&type=style&index=0&id=046cf616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046cf616",
  null
  
)

export default component.exports